'use client';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { theme } from '@/components/features/theme/theme';
import { gsap, Power2 } from 'gsap';

const CircleButton = ({
						  onSubmit,
						  text,
						  src,
						  submit,
						  img,
						  hoverImg,
						  fontSize,
						  fontWeight,
						  color,
						  letterSpacing,
						  lineHeight,
						  margin,
						  background,
						  borderRadius,
						  border,
						  width,
						  height,
						  hoverBackground,
						  target,
						  borderColor,
						  hoverColor,
						  icon,
						  marginSm,
						  onClick,
						  className,
					  }) => {
	const [preloaderButton, setPreloaderButton] = useState(null);
	const [circle, setCircle] = useState(null);
	const buttonRef = useRef(null);

	useEffect(() => {
		setPreloaderButton(buttonRef.current);
		setCircle(buttonRef.current);
	}, []);

	useEffect(() => {
		if (!preloaderButton) return;

		const callParallax = (e) => {
			parallaxIt(e, circle, 80);
		};

		const parallaxIt = (e, target, movement) => {
			const bounds = preloaderButton.getBoundingClientRect();
			const relX = e.pageX - bounds.left - window.scrollX;
			const relY = e.pageY - bounds.top - window.scrollY;

			gsap.to(target, {
				x: ((relX - bounds.width / 2) / bounds.width) * movement,
				y: ((relY - bounds.height / 2) / bounds.height) * movement,
				duration: 0.3,
				ease: Power2.easeOut,
			});
		};

		preloaderButton.addEventListener("mousemove", callParallax);

		return () => {
			preloaderButton.removeEventListener("mousemove", callParallax);
		};
	}, [preloaderButton, circle]);

	return (
		<StyledBtn
			ref={buttonRef}
			onClick={onClick}
			id={'preloader-click-button'}
			className={`${className ? className : ''} dc-btn`}
			fontSize={fontSize}
			fontWeight={fontWeight}
			color={color}
			background={background}
			lineHeight={lineHeight}
			letterSpacing={letterSpacing}
			margin={margin}
			border={border}
			img={img}
			borderRadius={borderRadius}
			width={width}
			hoverImg={hoverImg}
			hoverBackground={hoverBackground}
			height={height}
			borderColor={borderColor}
			target={target}
			hoverColor={hoverColor}
			onSubmit={onSubmit}
			icon={icon}
			marginSm={marginSm}
			submit={submit}
		>
			{submit ? (
				<a>
					<span>{text}</span>
				</a>
			) : (
				<Link href={src || '/'}>
					<span>{text}</span>
				</Link>
			)}
		</StyledBtn>
	);
};


const StyledBtn = styled.div`
    &.dc-btn {
        margin: ${props => props.margin || '0'};
        width: ${props => props.width || '180px'};
        height: ${props => props.height || '180px'};
        cursor: pointer;
        transition: ${theme.transition};

        a {
            display: flex;
            width: 100%;
            height: 100%;
            align-items: center;
            justify-content: center;
            font-size: ${props => props.fontSize || '1rem'};
            letter-spacing: ${props => props.letterSpacing || '-4%'};
            font-weight: ${props => props.fontWeight || theme.fontWeights.semiBold};
            margin: 0;
            line-height: ${props => props.lineHeight || '1.2'};
            background-color: ${props => props.background || 'transparent'};
            position: relative;
            border-radius: ${props => props.borderRadius || '50%'};
            overflow: hidden;
            padding: 0;
            box-sizing: border-box;
            border: ${p => p.border || '1px solid'};
            border-color: ${p => p.borderColor || theme.colors.themeColor400};
            color: ${props => props.color || theme.colors.text};
            z-index: 1;
            transition: ${theme.transition};

            &:after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) !important;
                width: 29px;
                height: 29px;
                border-radius: 50%;
                background-color: ${theme.colors.hover};
                transition: ${theme.transition};
                opacity: 0;
            }
    

            span {
                z-index: 99;
            }

            &:hover {
                span {
                    color: ${props => props.hoverColor || theme.colors.white};
                }

                &:after {
                    width: 100%;
                    height: 100%;
                    opacity: 1;
                }

            }

            &:focus {
                color: ${props => props.color || '#282d31'};
            }
        }

        @media (max-width: 600px) {
            ${p => p.marginSm ? `margin:${p.marginSm}` : ''}
        }
    }




`;


export default CircleButton;